"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
  };
  return function (d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
Object.defineProperty(exports, "__esModule", {
  value: true
});
var React = require("react");
var Campaign_1 = require("../models/Campaign");
var canUseDOM = typeof window !== "undefined";
var ABTest = function (_super) {
  __extends(ABTest, _super);
  function ABTest(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      selectedExperience: undefined,
      campaignEventReceived: false
    };
    _this.handleEvent = _this.handleEvent.bind(_this);
    _this.callbackExperience = _this.callbackExperience.bind(_this);
    _this.checkForExperience = _this.checkForExperience.bind(_this);
    _this.renderExperience = _this.renderExperience.bind(_this);
    return _this;
  }
  ABTest.prototype.componentDidMount = function () {
    var _this = this;
    if (!canUseDOM) {
      return;
    }
    var _a = this.props,
      campaign = _a.campaign,
      timeout = _a.timeout,
      subscribeFunc = _a.subscribeFunc;
    subscribeFunc(this.handleEvent, campaign);
    if (document.readyState === "complete") {
      window.setTimeout(this.checkForExperience, timeout);
      return;
    }
    window.addEventListener("load", function () {
      window.setTimeout(_this.checkForExperience, timeout);
    });
  };
  ABTest.prototype.checkForExperience = function () {
    if (!this.state.campaignEventReceived && !this.props.supressFallback) {
      this.setState({
        selectedExperience: 0
      });
      this.callbackExperience(0);
    }
  };
  ABTest.prototype.handleEvent = function (variantIndex) {
    this.setState({
      selectedExperience: variantIndex,
      campaignEventReceived: true
    });
    this.callbackExperience(variantIndex);
  };
  ABTest.prototype.callbackExperience = function (experienceId) {
    var campaign = this.props.campaign;
    var campaignObj = new Campaign_1.Campaign(experienceId, campaign);
    if (this.props.onExperience) {
      this.props.onExperience(campaignObj);
    }
  };
  ABTest.prototype.renderExperience = function (children, selectedExperience, campaign) {
    try {
      var experiencedReceived = children[selectedExperience];
      if (!experiencedReceived) {
        return null;
      }
      return experiencedReceived;
    } catch (err) {
      var errorMessage = "You do not have enough children to match the amount of experiences you have\n            configured.";
      // tslint:disable-next-line:no-console
      console.warn(errorMessage);
      return null;
    }
  };
  ABTest.prototype.render = function () {
    var _a = this.props,
      supressFallback = _a.supressFallback,
      placeholder = _a.placeholder,
      children = _a.children,
      campaign = _a.campaign;
    var selectedExperience = this.state.selectedExperience;
    if (!canUseDOM) {
      return null;
    }
    var noExperience = typeof selectedExperience === "undefined";
    if (!supressFallback && placeholder && noExperience) {
      var placeholderStyle = {
        visibility: "hidden"
      };
      return React.createElement("div", {
        style: placeholderStyle
      }, children[0]);
    } else if (selectedExperience === undefined) {
      return null;
    }
    return this.renderExperience(children, selectedExperience, campaign);
  };
  return ABTest;
}(React.Component);
ABTest.defaultProps = {
  timeout: 100,
  defaultExperience: 0
};
exports["default"] = ABTest;
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/components/ABTest.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/opt/atlassian/pipelines/agent/build/node_modules/react-controlled-ab/components/ABTest.js");
  }
}();